import * as React from "react";
import { connect } from 'react-redux'
import { MainPage } from './MainPage'
import { CategoryPage } from './CategoryPage'
import { DefaultPageLayout } from "src/fragments/PageLayout";
import {WithTranslation, withTranslation} from "react-i18next";
import {ActionType, ContactType} from "App/constants";
import {SubCategoryPage} from "./SubCategoryPage";
import {ConfigurationPage} from "Containers/ConfigurationPage";
import {ContactPage} from "Containers/ContactPage";
import {dismissConfiguration, fetchConfiguration} from "App/services";
import {Modal, Button, ModalHeader, ModalBody, ModalFooter} from "reactstrap";
import {UserState, extractCurrentUser} from "App/user";
import {ApplicationState} from "App/store";
import {Spinner} from "App/fragments/Spinner";
import {SpecialOfferPage} from "Containers/SpecialOfferPage";

interface StateToProps {
    location: string,
    configurationCookie:any|null,
    user: UserState|null
    showPreviousConfDialog: boolean
    showExpiredConfDialog: boolean
}

interface DispatchToProps {
    loadConfiguration: (configuration: any) => void
    dismissConfiguration: () => void
}

const mapStateToProps = (state: ApplicationState) : StateToProps => ( {
    location : state.location?state.location.type:'',//FIXME
    configurationCookie: state.configurationCookie,
    user: extractCurrentUser(state.configurationCookie),
    showPreviousConfDialog: !!(state.location&&state.location.type===ActionType.PAGE_MAIN&&state.configurationCookie&&!state.configurationCookie.expired&&state.configurationCookie.purchaseid&&state.configurationCookie.productformid),
    showExpiredConfDialog: !!(state.location&&state.location.type===ActionType.PAGE_MAIN&&state.configurationCookie&&state.configurationCookie.expired)
});

const mapDispatchToProps = (dispatch: any) : DispatchToProps => ({
    loadConfiguration: (configuration: any) => dispatch(fetchConfiguration(configuration.purchaseid, configuration.productformid, configuration.usedmaincategoryid, configuration.productfamilyiconid)),
    dismissConfiguration: () => dispatch(dismissConfiguration())
});

class _RootContainer extends React.Component<StateToProps & DispatchToProps & WithTranslation, any> {

    scenes = {
        [ActionType.PAGE_MAIN]: (user: UserState) => <MainPage />,
        [ActionType.PAGE_CATEGORY]: (user: UserState) => <CategoryPage />,
        [ActionType.PAGE_SUBCATEGORY]: (user: UserState) => <SubCategoryPage />,
        [ActionType.PAGE_SPECIALOFFER]: (user: UserState) => <SpecialOfferPage />,
        [ActionType.PAGE_CONFIGURATION]: (user: UserState) => <ConfigurationPage user={user}/>,
        [ActionType.PAGE_CONTRACT]: (user: UserState) => <ContactPage type={ContactType.CONTRACT} user={user}/>,
        [ActionType.PAGE_OFFER]: (user: UserState) => <ContactPage type={ContactType.OFFER} user={user}/>,
    };

    render () {
        const {t, configurationCookie, user, showPreviousConfDialog, showExpiredConfDialog, location, loadConfiguration, dismissConfiguration} = this.props;
        return <React.Fragment>
            <DefaultPageLayout
                user={user}
                mainFragment={
                    <React.Fragment>
                        {this.scenes[location](user)}
                    </React.Fragment>
                }
            />
            {
                showPreviousConfDialog ?
                    <Modal isOpen={showPreviousConfDialog}>
                        <ModalHeader>
                            <div className={"title-normal-uppercase"}>{t('products.configuration.previoustitle')}</div>
                        </ModalHeader>
                        <ModalBody>{t('products.configuration.pendingtext', {product: configurationCookie&&configurationCookie.currentconfigurationsummary? configurationCookie.currentconfigurationsummary: ' (?) '})}</ModalBody>
                        <ModalFooter>
                            <Button className="configure text-uppercase text-left button-height-48 d-flex align-items-center"
                                    onClick={() => dismissConfiguration()} disabled={configurationCookie.loading}>
                                <Spinner active={false} stillStyle={"far fa-trash pr-2 fa-lg"}/>
                                <div className={"d-inline pl-2"}>{t('products.configuration.discardprevious')}</div>
                            </Button>
                            <Button className="primary configure text-uppercase text-left button-height-48 d-flex align-items-center"
                                    onClick={() => !configurationCookie.loading&&loadConfiguration(configurationCookie)} >
                                <Spinner active={configurationCookie.loading} stillStyle={"far fa-check-circle pr-2 fa-lg"}/>
                                <div className={"d-inline pl-2"}>{t('products.configuration.continueprevious')}</div>
                            </Button>
                        </ModalFooter>
                    </Modal> :
                    (
                        showExpiredConfDialog ?
                        <Modal isOpen={showExpiredConfDialog}>
                            <ModalHeader>
                                <div className={"title-normal-uppercase"}>{t('products.configuration.removedtitle')}</div>
                            </ModalHeader>
                            <ModalBody>{t('products.configuration.removedtext', {product: configurationCookie&&configurationCookie.currentconfigurationsummary? configurationCookie.currentconfigurationsummary: ' (?) '})}</ModalBody>
                            <ModalFooter>
                                <Button className="configure text-uppercase text-left button-height-48 d-flex align-items-center"
                                        onClick={() => dismissConfiguration()}>
                                    <Spinner active={false} stillStyle={"far fa-trash pr-2 fa-lg"}/>
                                    <div className={"d-inline pl-2"}>{t('products.configuration.ok')}</div>
                                </Button>
                            </ModalFooter>
                        </Modal>:
                        null
                    )
            }
        </React.Fragment>
    }
}

export const RootContainer = connect(mapStateToProps, mapDispatchToProps)(withTranslation('common')(_RootContainer));



// WEBPACK FOOTER //
// ./src/containers/RootContainer.tsx